import React from 'react';
import { Link } from 'react-router-dom';

// Shared, themed presentation for the generic status/error pages. Reuses the
// layout chrome (rendered via the app shell) and the design theme tokens —
// nothing hard-coded.
export default function StatusPage({ code, title, message, icon = 'fa fa-exclamation-triangle', variant = 'primary' }) {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6 text-center">
          <div className="card">
            <div className="card-body py-5">
              <i className={`${icon} text-${variant}`} style={{ fontSize: '3.5rem' }} aria-hidden="true" />
              <h1 className="display-4 fw-bold mt-3 mb-0">{code}</h1>
              <h2 className="h4 mb-3">{title}</h2>
              <p className="text-muted mb-4">{message}</p>
              <div className="d-flex gap-2 justify-content-center">
                <Link to="/" className="btn btn-primary">
                  <i className="fa fa-home me-1" aria-hidden="true" />
                  Go to Dashboard
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
